export const faqs = [
  {
    q: "511爆料主要分为哪些板块？",
    a: "目前分为五大板块：娱乐圈瓜、职场瓜、校园瓜、同城瓜和行业瓜。每个板块都有独立的分类页面，可以从首页的分类快速直达入口直接进入，也可以随时用顶部搜索框按关键词查找。",
  },
  {
    q: "怎么快速找到我想看的那一类内容？",
    a: "最简单的方式是点击首页的「分类快速直达入口」，五个板块的图标和名称一目了然。进入分类页后，还可以按「最新」或「最热」排序，进一步缩小范围。",
  },
  {
    q: "内容更新频率大概是怎样的？",
    a: "各板块每天都会有新的内容进入，娱乐圈瓜和同城瓜通常更新更频繁，校园瓜和行业瓜相对稳定。首页的「最新爆料」会按发布时间实时排序，方便你判断哪些是刚上新的。",
  },
  {
    q: "网站上的内容可以转载吗？",
    a: "欢迎分享链接，但请注明来源并保留原文链接。如果需要整篇转载或用于商业用途，建议先通过联系邮箱与我们沟通，我们会尽快回复。",
  },
  {
    q: "看到的内容有疑问或者觉得不准确怎么办？",
    a: "可以通过「关于我们」页面里的联系邮箱反馈问题，并附上页面标题与链接。我们会优先核查涉及事实的部分，并尽快更新说明。",
  },
  {
    q: "可以自己投稿吗？",
    a: "可以。我们更欢迎带有真实场景和细节的观察类内容。投稿时建议写清楚时间、场景和你的身份视角，避免使用真实姓名和隐私信息，编辑部会协助做脱敏处理。",
  },
];